import React from 'react'
import {Stack, Typography} from '@mui/material'
import {useCountUp} from '@containers/dashboard/helpers/useCountUp'

interface IProps {
	value: number
	suffix?: string
	label: string
}

// The number counts to the new value and the label fades in, instead of both jumping.
const DonutCenter = ({value, suffix = '', label}: IProps) => {
	const shown = useCountUp(value, 350)

	return (
		<Stack sx={{position: 'absolute', inset: 0, pointerEvents: 'none'}} alignItems={'center'} justifyContent={'center'}>
			<Typography variant={'h5'} fontWeight={600} sx={{fontVariantNumeric: 'tabular-nums'}}>
				{shown.toLocaleString('uk-UA')}{suffix}
			</Typography>
			<Typography
				key={label}
				variant={'caption'}
				color={'text.secondary'}
				sx={{
					'@keyframes donutLabelIn': {
						from: {opacity: 0, transform: 'translateY(4px)'},
						to: {opacity: 1, transform: 'none'},
					},
					animation: 'donutLabelIn .25s ease',
				}}
			>
				{label}
			</Typography>
		</Stack>
	)
}

export default DonutCenter
